import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const wrapper = "_arawsnjakq";
const table = "_arat4f5bok";
const content = "_arac17zidek";
const backgroundIcon = "_arabrlmzk3";
const printTemplateInset = combineTokens("--print-template--inset", {
  top: units.px(75),
  bottom: units.px(90),
  left: units.px(60),
  right: units.px(60)
});

export { backgroundIcon, content, printTemplateInset, table, wrapper };
import "./_print-template.style.linaria.module.css";
//# sourceMappingURL=_print-template.style.js.map
